import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ICreateSalesData } from "../../../../@types";
import { CloseIcon } from "../../../../assets/icons";
import { editRecurringInvoice } from "../../../../backend-services";
import {
  REOCCURRING_FREQUENCY,
  REOCCURRING_REMINDER,
} from "../../../../constants";
import { InvoiceErrors } from "../../../../modules/validateInvoiceForm";
import { DropdownComponent, InputComponent } from "../../../core/Forms";
import LoadingSpinner from "../../../common/loadingSpinner";
import { showToast } from "../../../../utils/toastUtils";

interface InvoiceRecurringProps {
  handleDropDownChange: (name: string, value: string) => void;
  formData: ICreateSalesData;
  setFormData: React.Dispatch<React.SetStateAction<ICreateSalesData>>;
  handleInputChange: (event: { target: { name: any; value: any } }) => void;
  handleSave: () => void; // Add handleSave prop
  closeForm: () => void;
  setShowPrompt: (show: boolean) => void;
  id?: string;
  fetchInvoiceData: () => Promise<void>;
}

const EditPrompt: React.FC<InvoiceRecurringProps> = ({
  formData,
  setFormData,
  handleDropDownChange,
  handleInputChange,
  handleSave,
  closeForm,
  setShowPrompt,
  id,
  fetchInvoiceData,
}) => {
  const dropDownRepeatedly = REOCCURRING_FREQUENCY;
  const dropDownReminder = REOCCURRING_REMINDER;
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [endDate, setEndDate] = useState("");

  const [isDeleting, setIsDeleting] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");
  const navigate = useNavigate();

  const data = {
    reoccurringStatus: formData.reoccurringStatus,
    isReoccurringEndDate: formData.isReoccurringEndDate,
    reoccurringGroupName: formData.reoccurringGroupName,
    shouldSendWhatsapp: formData.shouldSendWhatsApp,
    shouldSendSMS: formData.shouldSendSMS,
  };

  const handleEditRecurringInvoice = async (id: any, data: any) => {
    try {
      setIsLoading(true);
      const response = await editRecurringInvoice({ id, data });
      setIsLoading(false);
      fetchInvoiceData();
      showToast("Recurring Invoice Updated Successfully", "success");
      setShowPrompt(false);
    } catch (error: any) {
      setIsLoading(false);
      setErrorMessage("Unable to update invoice.");
      if (
        error.response &&
        (error.response.status === 400 || error.response.status === 500)
      ) {
        navigate("/error");
      }
    }
  };

  return (
    <>
      {/* Desktop */}
      <div className="hidden lg:block md:block px-[1em]">
        <div className="flex justify-between">
          <h3 className="lg:text-[24px] font-normal right-2">
            Edit Recurring Invoice
          </h3>
          <button
            className=" py-[0.2em] pr-4"
            aria-label="Close modal"
            onClick={closeForm}
          >
            <CloseIcon color="black" />
          </button>
        </div>
        <div className="grid grid-cols-2 mt-[1em]">
          <div>
            <label>End Date</label>
            <InputComponent
              type="date"
              value={formData.isReoccurringEndDate || ""}
              className="w-[231px]"
              handleChange={handleInputChange}
              name="isReoccurringEndDate"
            />
          </div>
          <div className="flex mt-[2em] justify-end gap-2">
            <input
              type="checkbox"
              checked={!formData.isReoccurringEndDate}
              onChange={(e) => {
                const isChecked = e.target.checked;
                setFormData((prevData) => ({
                  ...prevData,
                  isReoccurringEndDate: isChecked ? "" : "some_date_value",
                }));
              }}
              name="isReoccurringEndDate"
            />
            <label className="font-normal mt-[-0.2em]">Repeat non-stop</label>
          </div>
        </div>

        <div className="mt-[1em]">
          <label>Repeat</label>
          <div className="mt-2 w-full">
            <DropdownComponent
              options={dropDownRepeatedly}
              name="reoccurringGroupName"
              placeholder="Frequency"
              selectedValue={formData.reoccurringGroupName || ""}
              onChange={handleDropDownChange}
              dropdownClassName="  w-[456px] bg-[#fff]   max-h-[48px] cursor-pointer  rounded-[4px] placeholder:text-[#A4A4A4] border-1 border-[#A4A4A4] mt-[-0.3em] mb-[1em]"
              iconClassName="mr-[1.5em] lg:mr-[2.5em] xl:mr-[1.5em] biglg:mr-[0.6em]"
            />
          </div>
        </div>

        {/* <div>
        <label>Select Reminder Channel</label>
        <div className='mt-2 w-full'>
          <DropdownComponent
            options={dropDownReminder}
            placeholder="Reminder Channel"
            name='reminderType'
            selectedValue={formData.reminderType} 
            onChange={handleDropDownChange}
            dropdownClassName=" w-[456px]  bg-[#fff]  max-h-[48px] cursor-pointer  rounded-[4px] placeholder:text-[#A4A4A4] border-1 border-[#A4A4A4] mt-[-0.3em] mb-[1em]"
            iconClassName="mr-[1.5em] lg:mr-[2.5em] xl:mr-[1.5em] biglg:mr-[0.6em]"
          />
        </div>
      </div> */}

        <div className="flex  gap-[2em] ">
          <button
            className="bg-[#ffffff] border border-[#044E97] text-[16px]  h-[48px]  lg:w-[216px] #044E97focus:ring-[#044E97] rounded-md text-[#044E97] bigmd:mr-[3em] bigmd:w-[172px]  md:w-[172px]  mt-[2em]  "
            onClick={closeForm}
          >
            Cancel
          </button>
          <button
            className="bg-[#044E97] text-[16px]  h-[48px] 540:mr-[5em] lg:w-[216px]  rounded-md text-[#ffffff] ml:[2em] md:mr-[1.8em] bigmd:mr-[3.6em] bigmd:w-[172px] mt-[2em]  md:w-[172px] lg:mr-[-0.5em]  xl:mr-[0.5em] mb-[2em]"
            onClick={() => handleEditRecurringInvoice(id, data)}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <LoadingSpinner />
              </>
            ) : (
              "Save"
            )}
          </button>
        </div>
      </div>

      {/* Mobile */}
      {/* <div className='md:hidden'> */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 rounded-t-full">
        <div className="bg-white p-4 border-t">
          <div className="flex w-full justify-between py-3">
            <div className="flex justify-start font-semibold text-[20px]">
              Edit Recurring Invoice
            </div>
            <div onClick={closeForm}>
              <CloseIcon color="#212121" />
            </div>
          </div>
          <div className="w-full text-[16px] mt-2">
            <div>
              <label>End Date</label>
              <InputComponent
                type="date"
                value={formData.isReoccurringEndDate}
                className="w-full"
                handleChange={handleInputChange}
                name="isReoccurringEndDate"
              />
            </div>
          </div>

          <div className="mt-[1em]">
            <label>Repeat</label>
            <div className="mt-2 w-full px-0.5">
              <DropdownComponent
                options={dropDownRepeatedly}
                placeholder="Frequency"
                selectedValue={formData.reoccurringGroupName}
                onChange={handleDropDownChange}
                dropdownClassName="  w-full bg-[#fff] lg:w-[300px]  max-h-[48px] cursor-pointer xl:w-[434px] rounded-[4px] placeholder:text-[#A4A4A4] border-1 border-[#A4A4A4] mt-[-0.3em] ml-[-0.3em] mb-[1em]"
                iconClassName="mr-[1.5em] lg:mr-[2.5em] xl:mr-[0.5em]"
              />
            </div>
            <div className="flex mt-[1em] items-center gap-2">
              <input
                type="checkbox"
                checked={!formData.isReoccurringEndDate}
                onChange={(e) => {
                  const isChecked = e.target.checked;
                  setFormData((prevData) => ({
                    ...prevData,
                    isReoccurringEndDate: isChecked ? "" : "some_date_value",
                  }));
                }}
                name="isReoccurringEndDate"
              />
              <label className="font-normal text-[14px] mt-[0.2em]">
                Repeat non-stop
              </label>
            </div>
          </div>

          {/* <div>
        <label>Select Reminder Channel</label>
        <div className='mt-2 w-full'>
          <DropdownComponent
            options={dropDownReminder}
            placeholder="Reminder Channel"
            dropdownClassName="  w-full bg-[#fff] lg:w-[300px]  max-h-[48px] cursor-pointer xl:w-[434px] rounded-[4px] placeholder:text-[#A4A4A4] border-1 border-[#A4A4A4] mt-[-0.3em] ml-[-0.3em] mb-[1em]"
            iconClassName="mr-[1.5em] lg:mr-[2.5em] xl:mr-[0.5em]"
          />
        </div>
      </div> */}

          <div className="flex py-6 gap-[2em] my-3">
            <button
              className="bg-[#ffffff] border border-[#044E97] text-[16px]  h-[48px]  w-full rounded-md text-[rgb(4,78,151)] "
              onClick={closeForm}
            >
              Cancel
            </button>
            <button
              className="bg-[#044E97] text-[16px]  h-[48px] 540:mr-[5em] w-full rounded-md text-[#ffffff] "
              //   onClick={ServicesCreate}
              disabled={isLoading}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditPrompt;
